module.exports = __webpack_public_path__ + "img/wave-sound.bff6e06a.svg";